import "../css/Login.css";

import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import validatePasswordFormat from "../passwordValidator";

function ResetPassword() {
  const customer = useSelector((state) => state.customer);
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [warning, setWarning] = useState(null);
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (password !== passwordConfirm) return setWarning("Passwords do not match!");
    if (!validatePasswordFormat(password))
      return setWarning("The Password given does not adhere to the format we require.");
    try {
      const response = await axios({
        method: "patch",
        url: `${process.env.REACT_APP_API_URL}/customers/reset-password`,
        data: { password },
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log(response.data);
      dispatch({ type: "LOGIN", payload: response.data.customer });
      dispatch({ type: "MODIFY_CART_CONTENT", payload: response.data.shoppingCartContent });
      navigate("/");
    } catch (err) {
      console.log(err.response.data.msg);
      setWarning("Authentication failed.");
    }
  };

  useEffect(() => {
    if (customer) navigate("/edit-my-info");
  }, []);

  return (
    <div className="container w-75">
      <Link className="text-center d-block mt-4 mb-3" to="/">
        <span className="text-dark brand-name">
          SUPERPOWER
          <i className="bi bi-lightning-fill text-dark"></i>
        </span>
      </Link>
      <div className="card border-0 shadow-lg rounded-3 initiate-session-panel">
        <div className="card-body p-5">
          <form onSubmit={handleSubmit}>
            <h1 className="fs-2">Reset Password</h1>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                New Password*
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                aria-describedby="password"
                value={password}
                placeholder="Password"
                onChange={(ev) => setPassword(ev.target.value)}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="passwordConfirm" className="form-label">
                Password confirm
              </label>
              <input
                type="password"
                className="form-control"
                id="passwordConfirm"
                aria-describedby="passwordConfirm"
                value={passwordConfirm}
                placeholder="Password confirm"
                onChange={(ev) => setPasswordConfirm(ev.target.value)}
              />
            </div>
            <p>(*) passwords must have one letter, one number, and at least 8 characters total.</p>
            {warning && <p className="text-danger me-3">{warning}</p>}
            <button className="btn submit-button mt-3">Save password</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
